// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Common = require("../utils/Common.res.js");
var Belt_Id = require("rescript/lib/js/belt_Id.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_HashSet = require("rescript/lib/js/belt_HashSet.js");
var MM_substitution = require("./MM_substitution.res.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.res.js");
var MM_progress_tracker = require("../utils/MM_progress_tracker.res.js");

function applyAssertionResultEq(a, b) {
  if (Belt_Option.isNone(a.err) && Belt_Option.isNone(b.err) && a.frame.label === b.frame.label) {
    return MM_substitution.subsEq(a.subs, b.subs);
  } else {
    return false;
  }
}

function applyAssertionResultHash(a) {
  return Expln_utils_common.hash2(Expln_utils_common.hashStr(a.frame.label), MM_substitution.subsHash(a.subs));
}

var ApplyAssertionResultHash = Belt_Id.MakeHashableU({
      hash: applyAssertionResultHash,
      eq: applyAssertionResultEq
    });

function iterateCombinationsRec(candidatesPerHyp, comb, hypIdx, skipCombinationsWithEmptyArgs, skipCombinationsWithoutEmptyArgs, combCnt, combCntMax, onCombCntMaxReached, combinationConsumer) {
  if (hypIdx === comb.length) {
    combCnt.contents = combCnt.contents + 1 | 0;
    if (combCnt.contents > combCntMax) {
      return onCombCntMaxReached();
    }
    var thereIsEmptyArg = comb.some(function (a) {
          return a === -1;
        });
    if (thereIsEmptyArg) {
      if (skipCombinationsWithEmptyArgs) {
        return "Continue";
      } else {
        return combinationConsumer(comb);
      }
    } else if (skipCombinationsWithoutEmptyArgs) {
      return "Continue";
    } else {
      return combinationConsumer(comb);
    }
  }
  var res = "Continue";
  var c = 0;
  var maxC = candidatesPerHyp[hypIdx].length - 1 | 0;
  while(res === "Continue" && c <= maxC && combCnt.contents <= combCntMax) {
    comb[hypIdx] = candidatesPerHyp[hypIdx][c];
    if (!(comb[hypIdx] === -1 && skipCombinationsWithEmptyArgs)) {
      res = iterateCombinationsRec(candidatesPerHyp, comb, hypIdx + 1 | 0, skipCombinationsWithEmptyArgs, skipCombinationsWithoutEmptyArgs, combCnt, combCntMax, onCombCntMaxReached, combinationConsumer);
    }
    c = c + 1 | 0;
  };
  return res;
}

function iterateCombinations(numOfStmts, numOfHyps, stmtCanMatchHyp, combCntMax, debugLevel, combinationConsumer, errConsumer) {
  var candidatesPerHyp = Belt_Array.makeBy(numOfHyps, (function (param) {
          return [];
        }));
  var maxH = numOfHyps - 1 | 0;
  var maxS = numOfStmts - 1 | 0;
  for(var h = 0; h <= maxH; ++h){
    for(var s = -1; s <= maxS; ++s){
      if (stmtCanMatchHyp(s, h)) {
        candidatesPerHyp[h].push(s);
      }
      
    }
  }
  var idx = candidatesPerHyp.findIndex(function (candidates) {
        return candidates.length === 0;
      });
  if (idx !== -1) {
    if (debugLevel >= 2) {
      return errConsumer({
                  TAG: "NoUnifForArg",
                  args: [],
                  errArgIdx: idx
                });
    } else {
      return "Continue";
    }
  }
  var comb = Belt_Array.make(numOfHyps, 0);
  var tooBigSearchSpaceDetected = {
    contents: false
  };
  var $$continue = iterateCombinationsRec(candidatesPerHyp, comb, 0, true, false, {
        contents: 0
      }, combCntMax, (function () {
          tooBigSearchSpaceDetected.contents = true;
          return errConsumer({
                      TAG: "TooManyCombinations",
                      frmLabels: undefined
                    });
        }), combinationConsumer);
  if ($$continue === "Continue") {
    return iterateCombinationsRec(candidatesPerHyp, comb, 0, false, true, {
                contents: 0
              }, combCntMax, (function () {
                  if (tooBigSearchSpaceDetected.contents) {
                    return "Continue";
                  } else {
                    return errConsumer({
                                TAG: "TooManyCombinations",
                                frmLabels: undefined
                              });
                  }
                }), combinationConsumer);
  } else {
    return $$continue;
  }
}

function stmtCanMatchHyp(frm, hypIdx, stmt, hyp, parenCnt) {
  if (hyp[0] !== stmt[0]) {
    return false;
  }
  var res = {
    contents: false
  };
  MM_substitution.iterateSubstitutions(hyp, stmt, frm.frmConstParts[hypIdx], frm.constParts[hypIdx], frm.varGroups[hypIdx], frm.subs, parenCnt, (function (param) {
          res.contents = true;
          return "Stop";
        }));
  return res.contents;
}

function iterateSubstitutionsWithWorkVars(workVars, frm, allowNewVars, hypIdx, $$continue) {
  var initialNumOfWorkVars = workVars.newVars.length;
  var predefinedSubs = frm.subs.isDefined.slice();
  var nextVar = {
    contents: (workVars.maxVar + 1 | 0) + workVars.newVars.length | 0
  };
  var frmVars = [];
  var newVars = [];
  var newVarTypes = [];
  MM_substitution.applySubs(hypIdx < frm.hypsE.length ? frm.hypsE[hypIdx].expr : frm.frame.asrt, frm.subs, (function (frmVar) {
          var idx = frmVars.indexOf(frmVar);
          if (idx !== -1) {
            return newVars[idx];
          }
          var newVar = nextVar.contents;
          nextVar.contents = nextVar.contents + 1 | 0;
          frmVars.push(frmVar);
          newVars.push(newVar);
          newVarTypes.push(frm.frame.varTypes[frmVar]);
          return newVar;
        }));
  var maxI = frmVars.length - 1 | 0;
  for(var i = 0; i <= maxI; ++i){
    var frmVar = frmVars[i];
    var newVar = newVars[i];
    var newVarType = newVarTypes[i];
    frm.subs.exprs[frmVar] = [newVar];
    frm.subs.begins[frmVar] = 0;
    frm.subs.ends[frmVar] = 0;
    frm.subs.isDefined[frmVar] = true;
    workVars.newVars.push(newVar);
    workVars.newVarTypes.push(newVarType);
  }
  var res = allowNewVars || workVars.newVars.length === 0 ? $$continue() : "Continue";
  predefinedSubs.forEach(function (predefined, i) {
        frm.subs.isDefined[i] = predefined;
      });
  workVars.newVars.splice(initialNumOfWorkVars);
  workVars.newVarTypes.splice(initialNumOfWorkVars);
  return res;
}

function getNextNonBlankIdx(hypIdx, comb) {
  var idx = hypIdx + 1 | 0;
  while(idx < comb.length && comb[idx] < 0) {
    idx = idx + 1 | 0;
  };
  if (idx < comb.length && comb[idx] >= 0) {
    return idx;
  }
  
}

function getNextBlankIdx(hypIdx, comb) {
  var idx = hypIdx + 1 | 0;
  while(idx < comb.length && comb[idx] >= 0) {
    idx = idx + 1 | 0;
  };
  if (idx < comb.length && comb[idx] < 0) {
    return idx;
  }
  
}

function getNextHypIdxToMatch(hypIdx, comb) {
  if (hypIdx >= comb.length) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "getNextHypIdxToMatch: hypIdx >= comb->Array.length"
          },
          Error: new Error()
        };
  }
  if (hypIdx < 0 || comb[hypIdx] >= 0) {
    var idx = getNextNonBlankIdx(hypIdx, comb);
    if (idx !== undefined) {
      return idx;
    }
    var idx$1 = getNextBlankIdx(-1, comb);
    if (idx$1 !== undefined) {
      return idx$1;
    } else {
      return comb.length;
    }
  }
  var idx$2 = getNextBlankIdx(hypIdx, comb);
  if (idx$2 !== undefined) {
    return idx$2;
  } else {
    return comb.length;
  }
}

function iterateSubstitutionsForHyps(workVars, frm, parenCnt, statements, allowNewVars, comb, hypIdx, debugLevel, onMatchFound, onErrFound) {
  var combToArgs = function () {
    return comb.map(function (idx) {
                if (idx >= 0) {
                  return statements[idx];
                } else {
                  return [];
                }
              });
  };
  if (hypIdx === comb.length) {
    var subsFound = {
      contents: false
    };
    var contunieInstruction = iterateSubstitutionsWithWorkVars(workVars, frm, allowNewVars, hypIdx, (function () {
            subsFound.contents = true;
            return onMatchFound();
          }));
    if (debugLevel >= 2 && !subsFound.contents) {
      return onErrFound({
                  TAG: "NewVarsAreDisabled",
                  args: combToArgs(),
                  errArgIdx: hypIdx
                });
    } else {
      return contunieInstruction;
    }
  }
  if (comb[hypIdx] >= 0) {
    var subsFound$1 = {
      contents: false
    };
    var contunieInstruction$1 = MM_substitution.iterateSubstitutions(frm.hypsE[hypIdx].expr, statements[comb[hypIdx]], frm.frmConstParts[hypIdx], frm.constParts[hypIdx], frm.varGroups[hypIdx], frm.subs, parenCnt, (function (param) {
            subsFound$1.contents = true;
            return iterateSubstitutionsForHyps(workVars, frm, parenCnt, statements, allowNewVars, comb, getNextHypIdxToMatch(hypIdx, comb), debugLevel, onMatchFound, onErrFound);
          }));
    if (debugLevel >= 2 && !subsFound$1.contents) {
      return onErrFound({
                  TAG: "NoUnifForArg",
                  args: combToArgs(),
                  errArgIdx: hypIdx
                });
    } else {
      return contunieInstruction$1;
    }
  }
  var subsFound$2 = {
    contents: false
  };
  var contunieInstruction$2 = iterateSubstitutionsWithWorkVars(workVars, frm, allowNewVars, hypIdx, (function () {
          subsFound$2.contents = true;
          return iterateSubstitutionsForHyps(workVars, frm, parenCnt, statements, allowNewVars, comb, getNextHypIdxToMatch(hypIdx, comb), debugLevel, onMatchFound, onErrFound);
        }));
  if (debugLevel >= 2 && !subsFound$2.contents) {
    return onErrFound({
                TAG: "NewVarsAreDisabled",
                args: combToArgs(),
                errArgIdx: hypIdx
              });
  } else {
    return contunieInstruction$2;
  }
}

function checkDisj(frmDisj, subs, maxCtxVar, allowNewDisjForExistingVars, isDisjInCtx, debugLevel) {
  return MM_substitution.verifyDisjoints(frmDisj, subs, (function (n, m) {
                if (n <= maxCtxVar && m <= maxCtxVar && !isDisjInCtx(n, m)) {
                  return allowNewDisjForExistingVars;
                } else {
                  return true;
                }
              }), debugLevel);
}

function iterateSubstitutionsForResult(frm, result, parenCnt, consumer) {
  if (result !== undefined) {
    return MM_substitution.iterateSubstitutions(frm.frame.asrt, result, frm.frmConstParts[frm.numOfHypsE], frm.constParts[frm.numOfHypsE], frm.varGroups[frm.numOfHypsE], frm.subs, parenCnt, consumer);
  } else {
    return consumer(frm.subs);
  }
}

function countFrames(frms, frmsToUse, result) {
  if (frmsToUse !== undefined) {
    return frmsToUse.length;
  }
  if (result === undefined) {
    return MM_substitution.frmsGetAll(frms).length;
  }
  var frames = MM_substitution.frmsGetByType(frms, result[0]);
  if (frames !== undefined) {
    return frames.length;
  } else {
    return 0;
  }
}

function applyAssertions(maxVar, frms, frmsToUse, isFrameAllowed, isDisjInCtx, statements, exactOrderOfStmtsOpt, allowEmptyArgsOpt, allowNewVarsOpt, result, parenCnt, allowNewDisjForExistingVarsOpt, combCntMaxOpt, onMatchFound, debugLevelOpt, onProgress) {
  var exactOrderOfStmts = exactOrderOfStmtsOpt !== undefined ? exactOrderOfStmtsOpt : false;
  var allowEmptyArgs = allowEmptyArgsOpt !== undefined ? allowEmptyArgsOpt : true;
  var allowNewVars = allowNewVarsOpt !== undefined ? allowNewVarsOpt : true;
  var allowNewDisjForExistingVars = allowNewDisjForExistingVarsOpt !== undefined ? allowNewDisjForExistingVarsOpt : false;
  var combCntMax = combCntMaxOpt !== undefined ? combCntMaxOpt : 10000;
  var debugLevel = debugLevelOpt !== undefined ? debugLevelOpt : 0;
  var sendNoUnifForAsrt = function (frm) {
    if (result !== undefined) {
      return onMatchFound({
                  newVars: [],
                  newVarTypes: [],
                  frame: frm.frame,
                  subs: MM_substitution.subsClone(frm.subs),
                  err: {
                    TAG: "NoUnifForAsrt",
                    asrtExpr: frm.frame.asrt,
                    expr: result
                  }
                });
    } else {
      return "Continue";
    }
  };
  var numOfStmts = statements.length;
  var numOfFrames = countFrames(frms, frmsToUse, result);
  var progressState = MM_progress_tracker.progressTrackerMake(0.01, undefined, onProgress, undefined);
  var framesProcessed = {
    contents: 0
  };
  var continueInstr = {
    contents: "Continue"
  };
  var sentValidResults = Belt_HashSet.make(16, ApplyAssertionResultHash);
  var frmConsumer = function (frm) {
    if (continueInstr.contents === "Continue") {
      if (Belt_Option.getWithDefault(Belt_Option.map(result, (function (result) {
                    return result[0] !== frm.frame.asrt[0];
                  })), false)) {
        if (debugLevel >= 2) {
          continueInstr.contents = sendNoUnifForAsrt(frm);
        }
        
      } else {
        var subsForResFound = {
          contents: false
        };
        continueInstr.contents = iterateSubstitutionsForResult(frm, result, parenCnt, (function (param) {
                subsForResFound.contents = true;
                var numOfHyps = frm.numOfHypsE;
                var workVars_newVars = [];
                var workVars_newVarTypes = [];
                var workVars = {
                  maxVar: maxVar,
                  newVars: workVars_newVars,
                  newVarTypes: workVars_newVarTypes
                };
                return iterateCombinations(numOfStmts, numOfHyps, (function (s, h) {
                              if (s === -1) {
                                if (exactOrderOfStmts) {
                                  return false;
                                } else {
                                  return allowEmptyArgs;
                                }
                              } else if (!exactOrderOfStmts || s === h) {
                                return stmtCanMatchHyp(frm, h, statements[s], frm.hypsE[h].expr, parenCnt);
                              } else {
                                return false;
                              }
                            }), combCntMax, debugLevel, (function (comb) {
                              return iterateSubstitutionsForHyps(workVars, frm, parenCnt, statements, allowNewVars, comb, getNextHypIdxToMatch(-1, comb), debugLevel, (function () {
                                            var err = checkDisj(frm.frame.disj, frm.subs, maxVar, allowNewDisjForExistingVars, isDisjInCtx, debugLevel);
                                            if (err !== undefined) {
                                              if (debugLevel === 0) {
                                                return "Continue";
                                              }
                                              var res_newVars = workVars_newVars.slice();
                                              var res_newVarTypes = workVars_newVarTypes.slice();
                                              var res_frame = frm.frame;
                                              var res_subs = MM_substitution.subsClone(frm.subs);
                                              var res_err = err;
                                              var res = {
                                                newVars: res_newVars,
                                                newVarTypes: res_newVarTypes,
                                                frame: res_frame,
                                                subs: res_subs,
                                                err: res_err
                                              };
                                              return onMatchFound(res);
                                            }
                                            var res_newVars$1 = workVars_newVars.slice();
                                            var res_newVarTypes$1 = workVars_newVarTypes.slice();
                                            var res_frame$1 = frm.frame;
                                            var res_subs$1 = MM_substitution.subsClone(frm.subs);
                                            var res$1 = {
                                              newVars: res_newVars$1,
                                              newVarTypes: res_newVarTypes$1,
                                              frame: res_frame$1,
                                              subs: res_subs$1,
                                              err: undefined
                                            };
                                            if (Belt_HashSet.has(sentValidResults, res$1)) {
                                              return "Continue";
                                            } else {
                                              Belt_HashSet.add(sentValidResults, res$1);
                                              return onMatchFound(res$1);
                                            }
                                          }), (function (err) {
                                            return onMatchFound({
                                                        newVars: [],
                                                        newVarTypes: [],
                                                        frame: frm.frame,
                                                        subs: MM_substitution.subsClone(frm.subs),
                                                        err: err
                                                      });
                                          }));
                            }), (function (err) {
                              return onMatchFound({
                                          newVars: [],
                                          newVarTypes: [],
                                          frame: frm.frame,
                                          subs: MM_substitution.subsClone(frm.subs),
                                          err: err
                                        });
                            }));
              }));
        if (debugLevel >= 2 && !subsForResFound.contents) {
          continueInstr.contents = sendNoUnifForAsrt(frm);
        }
        
      }
    }
    framesProcessed.contents = framesProcessed.contents + 1;
    MM_progress_tracker.progressTrackerSetCurrPct(progressState, framesProcessed.contents / numOfFrames);
  };
  if (frmsToUse !== undefined) {
    frmsToUse.forEach(function (frmLabel) {
          Belt_Option.forEach(MM_substitution.frmsGetByLabel(frms, frmLabel), (function (frm) {
                  if (isFrameAllowed(frm.frame)) {
                    return frmConsumer(frm);
                  }
                  
                }));
        });
    return ;
  } else {
    return MM_substitution.frmsForEach(frms, Belt_Option.map(result, (function (expr) {
                      return expr[0];
                    })), (function (frm) {
                  if (isFrameAllowed(frm.frame)) {
                    return frmConsumer(frm);
                  }
                  
                }));
  }
}

exports.applyAssertionResultEq = applyAssertionResultEq;
exports.applyAssertionResultHash = applyAssertionResultHash;
exports.ApplyAssertionResultHash = ApplyAssertionResultHash;
exports.applyAssertions = applyAssertions;
exports.iterateCombinations = iterateCombinations;
exports.getNextHypIdxToMatch = getNextHypIdxToMatch;
/* ApplyAssertionResultHash Not a pure module */
